export default __webpack_public_path__ + "static/media/bg-bubble-mid.b5486a8e.png";